
import React from 'react';
import { useAuth } from "@/contexts/auth";
import { usePermissions } from "@/hooks/use-permissions";
import ThemeToggle from "@/components/layout/ThemeToggle";
import UserProfileButton from "@/components/layout/UserProfileButton";

interface AdminHeaderProps {
  children?: React.ReactNode;
  onMenuClick?: () => void;
}

const AdminHeader = ({ children, onMenuClick }: AdminHeaderProps) => {
  return (
    <header className="bg-white dark:bg-gray-800 border-b border-nation-purple/20 dark:border-nation-purple/10 py-3 md:py-4 px-4 md:px-6 sticky top-0 z-10">
      <div className="flex justify-between items-center">
        <h1 className="text-lg md:text-xl font-bold text-nation-blue dark:text-blue-300 flex items-center">
          {children || "Dashboard Overview"}
        </h1>
        <div className="flex items-center gap-2 md:gap-4">
          <ThemeToggle />
          <UserProfileButton />
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
